import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import './BranchCreate.css'
import { MainLayout } from '../../Layout/MainLayout'

interface Regional {
    id: string
    name: string
    code: string
}

export function CreateBranch() {
    const navigate = useNavigate()
    const [regionais, setRegionais] = useState<Regional[]>([])
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')

    const [form, setForm] = useState({
        code: '',
        name: '',
        city: '',
        state: '',
        regionalId: ''
    })

    useEffect(() => {
        api.get('/regional').then(r => setRegionais(r.data?.data ?? r.data)).catch(() => { })
    }, [])

    function set(field: string, value: string) {
        setForm(prev => ({ ...prev, [field]: value }))
        setError('')
    }


    function validate() {
        if (!form.name.trim()) return 'Nome é obrigatório'
        if (!form.code.trim()) return 'Código é obrigatório'
        if (!form.city.trim()) return 'Cidade é obrigatória'
        if (!form.regionalId) return 'Regional é obrigatória'
        if (!form.state) return 'Estado é obrigatório'
        return null
    }

    async function handleSubmit() {
        const err = validate()
        if (err) { setError(err); return }

        setLoading(true)
        setError('')
        try {
            await api.post('/user', {
                name: form.name,
                code: form.code,
                city: form.city,
                state: form.state,
                regionalId: form.regionalId
            })
            setSuccess(true)
            setTimeout(() => navigate('/admin'), 1800)
        } catch (e: any) {
            setError(e.response?.data?.message || 'Erro ao criar Filial')
        } finally {
            setLoading(false)
        }
    }

    if (success) return (
        <MainLayout>
            <div className="cu-success-wrap">
                <div className="cu-success-icon">✓</div>
                <h2 className="serif">Filial criado!</h2>
                <p>Redirecionando para o painel...</p>
            </div>
        </MainLayout>
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/admin/')}>Admin</a>
                    <span className="sep">›</span>
                    <span>Nova Filial</span>
                </div>

                <div className="cu-layout">
                    <div className="cu-header">
                        <div className="kicker">Gestão de Filiais</div>
                        <h1 className="serif">Nova filial</h1>
                        <p>Preencha os dados da filial.</p>
                    </div>

                    <div className="cu-form-card">
                        {error && <div className="cu-error">{error}</div>}

                        <div className="cu-section-label">Dados da Filial</div>
                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Código *</label>
                                <input
                                    type="text"
                                    value={form.code}
                                    onChange={e => set('code', e.target.value)}
                                    placeholder="Código Filial"
                                />
                            </div>
                            <div className="field" style={{ flex: 2 }}>
                                <label>Nome *</label>
                                <input
                                    type="text"
                                    value={form.name}
                                    onChange={e => set('name', e.target.value)}
                                    placeholder="Nome da Filial"
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Cidade</label>
                                <input
                                    type="text"
                                    value={form.city}
                                    onChange={e => set('city', e.target.value)}
                                    placeholder="Cidade"
                                />
                            </div>
                            <div className="field" style={{ flex: 1 }}>
                                <label>Estado</label>
                                <input
                                    type="text"
                                    value={form.state}
                                    onChange={e => set('state', e.target.value)}
                                    placeholder="Estado"
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label>Regional</label>
                            <select
                                value={form.regionalId}
                                onChange={e => set('regionalId', e.target.value)}
                                className="cu-select"
                            >
                                <option value="">Selecione a Regional</option>
                                {regionais.map(b => (
                                    <option key={b.id} value={b.id}>
                                        {b.code} · {b.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="cu-actions">
                            <button
                                className="btn btn-ghost"
                                onClick={() => navigate('/admin')}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Criando...' : 'Criar filial →'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}